const locale = {
  placeholder: '请选择时间',
};

export default locale;
